(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/game-results/assets/javascripts/router.js') >= 0) return;  svs.modules.push('/modules/game-results/assets/javascripts/router.js');

'use strict';

svs.game_results.Router = Backbone.Router.extend({
  routes: svs.core.data.routes,
  routeStart() {
    if (svs.core.detect.formfactor.mobile()) {
      svs.core.template.updateConfig({
        title: {
          row1: {
            text: 'RESULTAT'
          }
        },
        headerClass: 'header-default'
      });
    }
  },
  routeStryket() {
    this.routeProduct('stryktipset');
  },
  routeEuropatipset() {
    this.routeProduct('europatipset');
  },
  routeChallenge() {
    this.routeProduct('challenge');
  },
  routeTopptipset() {
    this.routeProduct('topptipset');
  },
  routeMaltipset() {
    this.routeProduct('maltipset');
  },
  routeBomben() {
    this.routeProduct('bomben');
  },
  routeMatchen() {
    this.routeProduct('matchen');
  },
  routePowerplay() {
    this.routeProduct('powerplay');
  },
  routeProduct(product, drawNumbers, date) {
    let model;
    switch (product) {
      case 'stryktipset':
      case 'europatipset':
      case 'topptipset':
      case 'maltipset':
        model = new svs.game_results.models.CommonSport({
          product,
          useStatistics: true,
          date
        });
        break;
      case 'bomben':
      case 'challenge':
      case 'powerplay':
        model = new svs.game_results.models.SeveralRoundsSport({
          product,
          useStatistics: true,
          date
        });
        break;
      case 'matchen':
        model = new svs.game_results.models.CommonSport({
          product,
          useStatistics: true,
          date
        });
        break;
      default:
        this.routeStart();
    }
    const re = /^\d+[\d-]+?\d$/;
    if (re.test(drawNumbers)) {
      model.getResult({
        drawNumber: drawNumbers.split('-')
      }, date);
    } else {
      model.getGameResult();
    }
    svs.game_results.app.mainView.show(new svs.game_results.views.ResultOverview({
      model
    }));
  }
});

 })(window);